<template>
  <sui-modal class="wrapper" size="small" v-model="visible" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Update account
    </sui-modal-header>
    <sui-modal-content>
      <sui-form :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <FormAccount v-model="entity" :mode="mode" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions v-if="entity">
      <sui-button class="left floated basic" icon="door open" color="red" label-position="left" :disabled="isLeaveDisabled" basic v-if="!entity.member.isOwner" @click.prevent="leaveAccount()">Leave</sui-button>
      <sui-button class="left floated basic" icon="trash" color="red" label-position="left" :disabled="isDeleteDisabled" basic v-if="entity.member.isOwner" @click="deleteAccount()">Delete</sui-button>
      <sui-button class="left floated button" color="grey" :disabled="entity.id === user.defaultAcc" basic data-inverted data-tooltip="Enter to this account automaticaly after login" @click.prevent="setDefault()">
        Use{{entity.id === user.defaultAcc ? 'd' : ''}} by default
      </sui-button>
      <sui-button-group>
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors || !hasChanges || !access.accManagement" @click="submit()" data-goal="UPDATE_ACCOUNT_TRY">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </sui-button-group>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Success
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import cloneDeep from 'lodash/cloneDeep'
  import ModalForm from '@/mixins/ModalForm'
  import FormAccount from '@/components/forms/Account'
  import utils from '@/utils'

  export default {
    name: 'ModalUpdateAccount',
    mixins: [
      ModalForm,
    ],
    components: {
      FormAccount,
    },
    data() {
      return {
        newMode: 'updating',
      }
    },
    computed: {
      ...mapGetters(['access', 'account', 'accounts', 'user']),
      mode() {
        return this.newMode || 'updating'
      },
      isLeaveDisabled() {
        return this.accounts.filter(account => account.owner === this.user.id).length > 1
      },
      isDeleteDisabled() {
        return this.account.id === this.entity.id || this.entity.subscription.active
      },
    },
    methods: {
      open(entity, newMode) {
        this.visible = true
        this.newMode = newMode
        this.entity = cloneDeep(entity)
      },
      onSuccess() {
        this.close()
        utils.reachGoal('UPDATE_ACCOUNT_SUCCESS')
      },
      onFail() {
        utils.reachGoal('UPDATE_ACCOUNT_FAIL')
      },
      setDefault() {
        this.apiErrors = null
        utils.reachGoal('UPDATE_ACCOUNT_SET_DEFAULT_TRY')
        this.entity.useByDefault().then(() => {
          utils.reachGoal('UPDATE_ACCOUNT_SET_DEFAULT_SUCCESS')
        }).catch(error => {
          utils.reachGoal('UPDATE_ACCOUNT_SET_DEFAULT_FAIL')
          this.apiErrors = error
        })
      },
      leaveAccount() {
        return this.$modals.confirm.open({
          text: `<p>You are going to leave <b>${this.entity.name}</b> account.</p>`,
          callback: () => {
            this.apiErrors = null
            utils.reachGoal('UPDATE_ACCOUNT_LEAVE_TRY')
            this.entity.leave().then(() => {
              utils.reachGoal('UPDATE_ACCOUNT_LEAVE_SUCCESS')
              if (this.entity.id === this.account.id) {
                if (this.entity.id === this.user.defaultAcc) {
                  const otherAccount = this.accounts.find(account => account.id !== this.entity.id)
                  otherAccount.use()
                } else {
                  this.user._defaultAcc.use()
                }
              }
              this.close()
            }).catch(error => {
              utils.reachGoal('UPDATE_ACCOUNT_LEAVE_FAIL')
              this.apiErrors = error
            })
          },
        })
      },
      deleteAccount() {
        return this.$modals.confirm.open({
          text: `<p>You are going to delete <b>${this.entity.name}</b> account.</p>`,
          callback: () => {
            this.apiErrors = null
            utils.reachGoal('UPDATE_ACCOUNT_DELETE_TRY')
            this.entity.delete().then(() => {
              utils.reachGoal('UPDATE_ACCOUNT_DELETE_SUCCESS')
              this.close()
            }).catch(error => {
              utils.reachGoal('UPDATE_ACCOUNT_DELETE_FAIL')
              this.apiErrors = error
            })
          },
        })
      },
    },
    created() {
      this.$modals.updateAccount = this
    },
  }
</script>
